const state = () => ({
  layerState: false,// 职业规划首页遮罩层
  resumeDetail: {}
})

const mutations = {
  updateLayerState(state, value){
    state.layerState = value
  },
  updateResumeDetail(state, value){
    state.resumeDetail = value
  }
}

const actions = {

}


export default {
  namespaced: true,
  actions,
  mutations,
  state
}
